import { render, staticRenderFns } from "./QutaAuxiliary.vue?vue&type=template&id=28e6d1e3&scoped=true&"
import script from "./QutaAuxiliary.vue?vue&type=script&lang=js&"
export * from "./QutaAuxiliary.vue?vue&type=script&lang=js&"
import style0 from "./QutaAuxiliary.vue?vue&type=style&index=0&id=28e6d1e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6d1e3",
  null
  
)

export default component.exports